export default __webpack_public_path__ + "static/media/tenis10_1225x150px.bbcc64dc.jpg";